import React from "react";
import PropTypes from "prop-types";
import DependentRecord from "./DependentRecord";

const dependentArray = [
  { fieldNamePrefix: "Spouse", relationship: "Spouse" },
  { fieldNamePrefix: "FirstChild", relationship: "Child 1" },
  { fieldNamePrefix: "SecondChild", relationship: "Child 2" },
  { fieldNamePrefix: "ThirdChild", relationship: "Child 3" },
];

const Dependent = ({ data }) => {
  return (
    <fieldset>
      <table className="hdf-form">
        <thead>
          <tr className="table-title">
            <th colSpan="9">
              C) DEPENDENT(S) PARTICULARS – Complete this section only if you are applying insurance
              for your dependents.
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td rowSpan="2">Relationship</td>
            <td rowSpan="2">Name (as shown in NRIC / Passport)</td>
            <td rowSpan="2">NRIC/Passport/FIN</td>
            <td rowSpan="2" className="text-center">
              Sex
            </td>
            <td colSpan="3" className="text-center">
              Date of Birth
            </td>
            <td rowSpan="2" className="text-center">
              Height
              <br />
              (m)
            </td>
            <td rowSpan="2" className="text-center">
              Weight
              <br />
              (kg)
            </td>
          </tr>
          <tr className="text-center">
            <td>Day</td>
            <td>Month</td>
            <td>Year</td>
          </tr>
          {dependentArray.map((dependent, index) => (
            <DependentRecord {...{ ...dependent, data }} key={index} />
          ))}
        </tbody>
      </table>
    </fieldset>
  );
};

Dependent.propTypes = {
  data: PropTypes.object,
};

export default Dependent;



// WEBPACK FOOTER //
// ./components/employee/hdf_forms/RHI/RHIHD201907/Dependent.jsx